import { jsxs, jsx } from 'react/jsx-runtime';
import * as Ariakit from '@ariakit/react';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmAside, IconLlmX } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import style from './page-menu.module.scss.js';

// export type PageMenuPlacement = 'left' | 'right';
const PageMenu = () => {
  const label = useLabel();
  const {
    PageHistory
  } = useLlm(state => state.components);
  const asideEnabled = useLlm(state => state.asideEnabled);
  const history = useLlm(state => state.history);
  const {
    toggleAside
  } = useLlm(state => state.actions);
  return jsxs(Ariakit.DialogProvider, {
    open: asideEnabled,
    children: [jsx(Ariakit.DialogDisclosure, {
      render: jsx("button", {
        type: "button",
        className: getClassNames(style.menu),
        "aria-label": asideEnabled ? label('llm.menuClose') : label('llm.menuOpen'),
        "aria-pressed": asideEnabled,
        onClick: () => toggleAside(),
        children: jsx(IconLlmAside, {})
      })
    }), jsxs(Ariakit.Dialog, {
      className: style.dialog,
      "data-lenis-prevent": true,
      backdrop: jsx("div", {
        className: style.backdrop
      }),
      onClose: () => toggleAside(),
      children: [jsxs("div", {
        className: style.head,
        children: [jsx(IconLlmAside, {}), jsx(Ariakit.DialogHeading, {
          className: style.title,
          children: "Le tue ricerche"
        }), jsx(Ariakit.DialogDismiss, {
          render: jsx("button", {
            className: getClassNames(style.close),
            children: jsx(IconLlmX, {})
          })
        })]
      }), jsx("div", {
        className: style.listing,
        children: history.length > 0 ? history.map((item, i) => jsx(PageHistory, {
          item: item
        }, `history-${i}`)) : jsx("div", {
          className: style.empty,
          children: label('llm.historyEmpty')
        })
      })]
    })]
  });
};

export { PageMenu };
//# sourceMappingURL=page-menu.js.map
